import React from "react";
import { Survey } from "./survey-types";
import { useOutletContext } from "react-router-dom";
import SurveyDefinition from "./SurveyDefinition";

const SurveyDefinitionTab: React.FC = () => {
  const { survey } = useOutletContext<{ survey: Survey | undefined }>();
  return <>{survey && <SurveyDefinition survey={survey} />}</>;
};

export default SurveyDefinitionTab;
